import { schema } from "normalizr";

const FilterSchema = new schema.Entity("Filters");
const FilterArraySchema = new schema.Array(FilterSchema);

export { FilterSchema, FilterArraySchema };